
import { IconStarFilled } from '@ds/icons/IconStarFilled'
import { IconStarHalfFilled } from '@ds/icons/IconStarHalfFilled'
import { IconStarOutlined } from '@ds/icons/IconStarOutlined'

import { MAX_RATING } from '../../../constants'

import translations from './RatingIcons.translations'

export default {
  components: {
    IconStarFilled,
    IconStarHalfFilled,
    IconStarOutlined,
  },
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
    count: {
      type: Number,
      default: 0,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    maximum: {
      type: Number,
      default: MAX_RATING,
    },
    rate: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    translations: () => translations,
    empty() {
      return Math.max(0, Math.floor(this.maximum - this.rate))
    },
    full() {
      return Math.floor(this.rate)
    },
    half() {
      return !Number.isInteger(this.rate)
    },
    formattedRate() {
      return `${this.rate}/${this.maximum}`
    },
  },
}
